import type { DeepRequired } from '../fixtures.types'

const getProviderStatementDetails: DeepRequired<GetProviderStatementDetailsResponse> = {
  __typename: 'GetProviderStatementDetailsResponse',
  statement_type: 'MORTGAGE_PROVIDER_STATEMENT',
  rows: [],
  nextPage: null,
}

export default getProviderStatementDetails
